var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplicationStatusMessagesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "messages",
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.877,
    height: 51.863,
    viewBox: "0 0 58.877 51.863",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23777",
    "data-name": "Group 23777",
    transform: "translate(-1128.309 -178.802)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23744",
    "data-name": "Group 23744",
    transform: "translate(1128.309 178.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22785",
    "data-name": "Path 22785",
    d: "M6.354,41.266A1.726,1.726,0,0,1,5.29,39.673V34.5H1.725A1.724,1.724,0,0,1,0,32.773V1.725A1.724,1.724,0,0,1,1.725,0H29.554a1.724,1.724,0,0,1,1.725,1.725v20.7L27.829,34.5h-13.2L8.234,40.892A1.725,1.725,0,0,1,6.354,41.266Z",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22786",
    "data-name": "Path 22786",
    d: "M151.638,1.725A1.724,1.724,0,0,0,149.913,0H136V34.5h12.189l3.45-12.074Z",
    transform: "translate(-120.36)",
    fill: "#1c2448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22787",
    "data-name": "Path 22787",
    d: "M122.724,210A1.725,1.725,0,1,1,121,211.723,1.725,1.725,0,0,1,122.724,210",
    transform: "translate(-107.085 -185.849)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22788",
    "data-name": "Path 22788",
    d: "M96.174,73.8a1.724,1.724,0,0,1-1.725-1.725,6.924,6.924,0,0,1,2.759-5.518,1.725,1.725,0,1,0-2.759-1.381,1.725,1.725,0,0,1-3.45,0,5.175,5.175,0,1,1,8.278,4.142A3.458,3.458,0,0,0,97.9,72.073,1.724,1.724,0,0,1,96.174,73.8",
    transform: "translate(-80.535 -53.099)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22789",
    "data-name": "Path 22789",
    d: "M137.724,211.723A1.725,1.725,0,0,0,136,210v3.45a1.725,1.725,0,0,0,1.725-1.725",
    transform: "translate(-120.36 -185.849)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22790",
    "data-name": "Path 22790",
    d: "M137.724,65.174a1.715,1.715,0,0,1-.691,1.381,6.8,6.8,0,0,0-1.034.984V73.8a1.724,1.724,0,0,0,1.725-1.725,3.458,3.458,0,0,1,1.378-2.757A5.175,5.175,0,0,0,136,60v3.45a1.727,1.727,0,0,1,1.725,1.725",
    transform: "translate(-120.36 -53.099)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_22791",
    "data-name": "Path 22791",
    d: "M264.928,191.122l-6.394-6.394h-14.81A1.724,1.724,0,0,1,242,183V151.724A1.724,1.724,0,0,1,243.724,150h27.6a1.724,1.724,0,0,1,1.725,1.725V183a1.724,1.724,0,0,1-1.725,1.725h-3.45V189.9a1.725,1.725,0,0,1-2.944,1.22Z",
    transform: "translate(914.139 39.038)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22792",
    "data-name": "Path 22792",
    d: "M389.888,150H375.971v34.728H377.1l6.394,6.394a1.725,1.725,0,0,0,2.945-1.22v-5.175h3.45A1.724,1.724,0,0,0,391.613,183V151.724A1.724,1.724,0,0,0,389.888,150Z",
    transform: "translate(795.573 39.038)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22793",
    "data-name": "Path 22793",
    d: "M317.522,229.448h-13.8a1.725,1.725,0,1,1,0-3.45h13.8a1.725,1.725,0,1,1,0,3.45",
    transform: "translate(861.039 -28.221)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22794",
    "data-name": "Path 22794",
    d: "M317.522,289.447h-13.8a1.725,1.725,0,0,1,0-3.45h13.8a1.725,1.725,0,1,1,0,3.45",
    transform: "translate(861.039 -81.321)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22795",
    "data-name": "Path 22795",
    d: "M317.522,349.447h-13.8a1.725,1.725,0,0,1,0-3.45h13.8a1.725,1.725,0,1,1,0,3.45",
    transform: "translate(861.039 -134.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22796",
    "data-name": "Path 22796",
    d: "M382.99,346h-7.018v3.45h7.018a1.725,1.725,0,1,0,0-3.45",
    transform: "translate(795.572 -134.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22797",
    "data-name": "Path 22797",
    d: "M382.99,286h-7.018v3.45h7.018a1.725,1.725,0,1,0,0-3.45",
    transform: "translate(795.572 -81.321)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22798",
    "data-name": "Path 22798",
    d: "M382.99,226h-7.018v3.45h7.018a1.725,1.725,0,1,0,0-3.45",
    transform: "translate(795.572 -28.221)",
    fill: "#040227"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationStatusMessagesIcon);
export default __webpack_public_path__ + "static/media/application-status-messages-icon.e8fb3d5162e17c946b39cba700784e46.svg";
export { ForwardRef as ReactComponent };